<script setup lang="ts">
import {MAIN_EMAIL} from '~/constants';
import {companyInfoList} from "~/components/general/footer/components/footerContacts/constants/companyInfoList";
</script>

<template>
    <div
        id="footerContacts"
        class="footer-contacts"
    >
        <h2 class="footer-contacts__title">Наши контакты</h2>

        <div class="footer-contacts__info footer-contacts-info">
            <div class="footer-contacts-info__headling">
                общество с ограниченной ответственностью “сириус“
            </div>

            <div class="footer-contacts-info__list">
                <div
                    v-for="({key, value, withGap}, index) in companyInfoList"
                    :key="index"
                    :class="[{'footer-contacts-info__item--with-gap': withGap}]"
                    class="footer-contacts-info__item"
                >
                    <span class="footer-contacts-info__key">{{ key }}</span>
                    <span class="footer-contacts-info__value">{{ value }}</span>
                </div>
            </div>
        </div>

        <div class="footer-contacts__links">
            <div class="footer-contacts__item">
                <span class="footer-contacts__head">Телефон</span>
                <a
                    class="footer-contacts__link"
                    href="tel:78126481272"
                >
                    7 (812) 648-12-72
                </a>
            </div>

            <div class="footer-contacts__item">
            <span class="footer-contacts__head">Почта</span>
            <a
                :href="`mailto:${MAIN_EMAIL}`"
                class="footer-contacts__link"
            >
                {{ MAIN_EMAIL }}
            </a>
        </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    @import 'styles/footer-contacts';
</style>
